import StoryAssetsTabAssetView from 'backbone/story/views/assets/story_assets_tab_asset_view.js'
import StoryAssetsMixin from 'backbone/story/mixins/story_assets_mixin.js'
import Asset from 'backbone/platform/models/assets/asset.js'
import MultiAssetPickerView from 'backbone/platform/views/assets/multi_asset_picker_view.js'
import BackboneDispatcher from 'lib/backbone_dispatcher.js'

export default class StoryAssetsTabView extends Backbone.View
  events:
    "click .js-attach"                   : "showAssetPicker"
    "ajax:success .js-delete-assetting"  : "removeAsset"

  initialize: (options) ->
    @options = options

    @dispatcher = BackboneDispatcher.get_instance()
    @dispatcher.bind("s3UploadStart", @s3UploadStart)
    @dispatcher.bind("s3UploadComplete", @s3UploadComplete)
    @dispatcher.bind("addMediaLibraryAssetToStory", @attachMediaLibraryAssets)
    @dispatcher.bind("storyTabAssetDeleted", @reloadActivities)
    StoryAssetsMixin.applyMixin(this)

  setupS3Uploader: ->
    uploaderOptions =
      assetableType: "Story"
      assetableId: @options.storyId
      externalProcessing: true
      assetType: @options.assetType

    @dispatcher.trigger("setParentResourceOptions", uploaderOptions)

  showAssetPicker: ->
    @setupS3Uploader()
    @assetPicker = new MultiAssetPickerView(
      el: $("#asset-picker-modal .asset-content")
      mediaLibraryAccess: @options.mediaLibraryAccess
      brandProfileId: @options.brandProfileId
      assetsPicked: @attachMediaLibraryAssets
      page: "assets-rail"
      modalHeaderTitle: "Attach story assets"
      modalAttachText: "Up to 5GB per file"
    )

  s3UploadStart: (upload) =>
    return unless upload.assetType == @options.assetType
    return unless upload.assetableId == @options.storyId
    contently.ui.closeModal() if @assetPicker?

  s3UploadComplete: (upload) =>
    return unless upload.assetType == @options.assetType
    return unless upload.assetableId == @options.storyId
    asset = new Asset
      assetableType: "Story"
      assetableId: @options.storyId
      url: upload.url
      fileType: upload.filetype
    @addAssetToView(asset)

  attachMediaLibraryAssets: (assets) =>
    for asset in assets
      viewAsset = new Asset
        asset_id: asset.attributes.asset_id
        persisted: false
        assetableType: "Story"
        assetableId: @options.storyId
        mediaLibAsset: true
        url: asset.attributes.url
        title: asset.attributes.title
        thumb: asset.attributes.thumb
        filesize: asset.attributes.filesize
        createdBy: asset.attributes.creatorName
      @addAssetToView(viewAsset)

  addAssetToView: (asset) =>
    mediaLibraryAsset = new StoryAssetsTabAssetView(asset: asset)
    @$el.find(".file-list-container").prepend(mediaLibraryAsset.render().el)
    asset.save(@reloadAssets)
    @reloadActivities()

  removeAsset: (event) ->
    $(event.currentTarget).closest('.list-item-wrapper').fadeOut(-> $(this).remove())
    @reloadActivities()
    @reloadAssets()



// WEBPACK FOOTER //
// ./app/javascript/backbone/story/views/assets/story_assets_tab_view.js.coffee